(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    

/*---------------- Shop Slider ------------------*/
$('.shop-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      vertical: true,
      verticalSwiping: true,
      asNavFor: '.shop-slider-nav'
});
$('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.shop-slider',
    dots: false,
    arrows: false,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true
});
/*................popup gallery..................*/
    $('.shop-slider').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
      }
    });

  } catch(e) { console.error(e); }
})();

})();
